<template>
  <waiting-post/>
</template>

<script>
import WaitingPost from '../components/WaitingPost/index'
export default {
  components: {WaitingPost},

}
</script>

<style>

</style>
